import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Patchnotes } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Patchnotes.Pages.PATCHNOTES}`,
    name: Patchnotes.Pages.PATCHNOTES,
    component: () => import(/* webpackChunkName: "patchnotes" */ './views/Patchnotes.vue'),
    meta: {
      access_roles: RouteRoles[Patchnotes.Pages.PATCHNOTES],
    },
  },
];

export default routes;
